let blockCardsSocial = document.querySelector(".block-cards-social");
let imageTopLeft = blockCardsSocial.querySelector(
  ".block-cards-social__image-top-left"
);
let imageTopRight = blockCardsSocial.querySelector(
  ".block-cards-social__image-top-right"
);
let imageBottomLeft = blockCardsSocial.querySelector(
  ".block-cards-social__image-bottom-left"
);
let imageBottomRight = blockCardsSocial.querySelector(
  ".block-cards-social__image-bottom-right"
);

let scrollActive = false;
const duration = 0.35;
const positiveImpact = 0.3;
const threshold = 0.4;
const ease = "none";
const coordinates = {
  clientX: 0,
  clientY: 0,
};

const animate = (pointX, pointY) => {
  const positionX = pointX > 0 ? pointX * positiveImpact : pointX;
  const positionY = pointY > 0 ? pointY * positiveImpact : pointY;
  gsap.to(imageTopLeft, { x: positionX, y: positionY, duration, ease });
  gsap.to(imageTopRight, { x: -positionX, y: -positionY, duration, ease });
  gsap.to(imageBottomLeft, { x: positionX, y: positionY, duration, ease });
  gsap.to(imageBottomRight, { x: -positionX, y: -positionY, duration, ease });
};

const getCoordinates = ({ clientX, clientY }) => {
  coordinates.clientX = clientX;
  coordinates.clientY = clientY;

  const { top, left } = blockCardsSocial.getBoundingClientRect();
  const offsetX =
    clientX -
    left -
    blockCardsSocial.clientLeft -
    blockCardsSocial.clientWidth / 2;
  const offsetY =
    clientY -
    top -
    blockCardsSocial.clientTop -
    blockCardsSocial.clientHeight / 2;

  const translateXPercentage =
    (offsetX / blockCardsSocial.clientWidth) * 100 * threshold;
  const translateYPercentage =
    (offsetY / blockCardsSocial.clientHeight) * 100 * threshold;

  return {
    translateXPercentage,
    translateYPercentage,
  };
};

const updateImagePosition = (event) => {
  if (!scrollActive) return;

  const { translateXPercentage, translateYPercentage } = getCoordinates({
    clientX: event.clientX,
    clientY: event.clientY,
  });
  animate(translateXPercentage, translateYPercentage);
};

const updateImagePositionOnScroll = () => {
  if (!scrollActive) return;

  const { translateXPercentage, translateYPercentage } = getCoordinates({
    clientX: coordinates.clientX,
    clientY: coordinates.clientY,
  });
  animate(translateXPercentage, translateYPercentage);
};

const resetImagePosition = () => {
  animate(0, 0);
  scrollActive = !scrollActive;
};

const Initialize = () => {
  blockCardsSocial = document.querySelector(".block-cards-social");
  imageTopLeft = blockCardsSocial.querySelector(
    ".block-cards-social__image-top-left"
  );
  imageTopRight = blockCardsSocial.querySelector(
    ".block-cards-social__image-top-right"
  );
  imageBottomLeft = blockCardsSocial.querySelector(
    ".block-cards-social__image-bottom-left"
  );
  imageBottomRight = blockCardsSocial.querySelector(
    ".block-cards-social__image-bottom-right"
  );

  blockCardsSocial.addEventListener("mouseleave", resetImagePosition);
  blockCardsSocial.addEventListener("mouseenter", () => {
    scrollActive = !scrollActive;
  });

  document.addEventListener("mousemove", updateImagePosition);
  document.addEventListener("scroll", updateImagePositionOnScroll);
};

// GLOBAL APP CONTROLLER
const controller = {
  init() {},
  loaded() {
    Initialize();
  },
  resized() {},
  scrolled() {},
  keyDown() {},
  mouseUp() {},
};
export default controller;
